module.exports = __webpack_public_path__ + "static/media/SafetyMessage.1cf4c82a.png";